import { adminFacilityRequest } from "./adminFacilityRequest";

export default adminFacilityRequest;
